import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { policyRulesOptions } from './constants'

const HasPolicyRulesSelector = ({ onChange, value }) => {
  const { t } = useTranslation()

  const handleChange = e => onChange(e.target.value)

  return (
    <div>
      <ComboBox
        value={value}
        label={t('Tiene Policy Rules aplicadas')}
        fullWidth
        handleChange={handleChange}
        menuItems={policyRulesOptions.map(option => ({
          label: t(option.label),
          value: option.value,
        }))}
      />
    </div>
  )
}

export default HasPolicyRulesSelector
